import React from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';

import {
  clientErrorTracker,
  useSoyuzLocales,
  useSoyuzExperiment
} from '@spotahome/soyuz/client';

import { SpottyCat as SpottyCatComponent } from '@spotahome/ui-library';

import sendInviteEvent from '../../graphql/mutations/notifications';

import getGqlClient from '../../graphql/client';

import { emailSignupWithoutPassword } from '../../api/traditional-login-client';

const SpottyCat = ({ cities, isUserLogged, deviceType }) => {
  const { current: currentLocale } = useSoyuzLocales();
  const spottyCatContactUsExperiment = useSoyuzExperiment(
    'ShowSpottyCatContactUsDesktop'
  );

  const isSmartPhone = deviceType === 'smartphone';
  const showContactUs =
    !isSmartPhone &&
    spottyCatContactUsExperiment.get('behaviour') === 'variant';

  const handleSignupWithoutPass = async ({ email, marketingOptIn }) => {
    await emailSignupWithoutPassword({
      email,
      marketingOptIn,
      locale: currentLocale
    });
  };

  const handleInviteEvent = async payload => {
    try {
      sendInviteEvent(getGqlClient())({ input: payload });
    } catch (error) {
      clientErrorTracker.error({ error, source: 'SpottyCatModal' });
    }
  };

  return (
    <NoSSR>
      <SpottyCatComponent
        locale={currentLocale}
        cities={cities}
        onSuccess={handleInviteEvent}
        onSignupWithoutPassword={!isUserLogged && handleSignupWithoutPass}
        isUserLogged={isUserLogged}
        isWhatsappShown={isSmartPhone}
        isContactUsShown={showContactUs}
      />
    </NoSSR>
  );
};

SpottyCat.propTypes = {
  cities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isUserLogged: PropTypes.bool.isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired
};

export default SpottyCat;
